<!-- eslint-disable -->
<template>
  <div class="page_box">
    <sb-headline :title="'平台裂变活动'"></sb-headline>
    <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading">
      <!-- 表格数据搜索 -->
      <template #header="params">
        <div class="search_box">
          <el-form :inline="true" :model="searchData" label-position="left" class="search-form">
            <div class="form-content">
              <el-form-item label="活动ID">
                <el-input 
                  v-model="searchData.activityCode" 
                  placeholder="请输入活动ID" 
                  clearable 
                  size="small"
                  prefix-icon="el-icon-search">
                </el-input>
              </el-form-item>
              <el-form-item label="活动名称">
                <el-input 
                  v-model="searchData.activityName" 
                  placeholder="请输入活动名称" 
                  clearable 
                  size="small"
                  prefix-icon="el-icon-search">
                </el-input>
              </el-form-item>
              <el-form-item label="活动状态">
                <el-select 
                  v-model="searchData.state" 
                  placeholder="请选择活动状态" 
                  size="small"
                  clearable>
                  <el-option label="草稿" value="0"></el-option>
                  <el-option label="未开始" value="1"></el-option>
                  <el-option label="进行中" value="2"></el-option>
                  <el-option label="已结束" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="前端是否展示">
                <el-select 
                  v-model="searchData.isShow" 
                  placeholder="请选择是否展示" 
                  size="small"
                  clearable>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-footer">
              <el-button 
                @click="resetSearchData" 
                size="small" 
                icon="el-icon-refresh">
                重置
              </el-button>
              <el-button 
                @click="pageHandler(params, 1)" 
                type="primary" 
                size="small" 
                icon="el-icon-search">
                查询
              </el-button>
            </div>
          </el-form>
        </div>
      </template>
      <template #navBar>
        <div class="table_nav_bar">
          <router-link to="/management/fission/fission-campagin-add">
            <el-button type="primary">新建活动</el-button>
          </router-link>
        </div>
      </template>
      <el-table-column label="活动ID" prop="activityCode" :min-width="200" fixed="left">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="gotoDetail(scope.row)">{{ scope.row.activityCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="活动信息" :min-width="400">
        <template slot-scope="scope">
          <div class="activity-info">
            <div class="activity-image">
              <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.bannerImage"
                :preview-src-list="[scope.row.bannerImage]"
                fit="cover">
              </el-image>
            </div>
            <div class="activity-detail">
              <div class="activity-header">
                <div class="activity-name" :title="scope.row.activityName">{{ scope.row.activityName }}</div>
                <div class="activity-status">
                  <el-tag
                    :type="getStatusType(scope.row.state)"
                    size="mini">
                    {{ getStatusText(scope.row.state) }}
                  </el-tag>
                </div>
              </div>
              <div class="activity-time">
                <div class="time-item">
                  <span class="time-label">开始：</span>
                  <span class="time-value">{{ scope.row.startTime }}</span>
                </div>
                <div class="time-item">
                  <span class="time-label">结束：</span>
                  <span class="time-value">{{ scope.row.endTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="浏览PV" prop="browsePvCount" :min-width="100"></el-table-column>
      <el-table-column label="浏览UV" prop="browseUvCount" :min-width="100"></el-table-column>
      <el-table-column label="分享PV" prop="sharePvCount" :min-width="100"></el-table-column>
      <el-table-column label="分享UV" prop="shareUvCount" :min-width="100"></el-table-column>
      <el-table-column label="购买单数" prop="purchaseCount" :min-width="100"></el-table-column>
      <el-table-column label="购买人数" prop="purchaseUserCount" :min-width="100"></el-table-column>
<!--      <el-table-column label="活动状态" prop="state" :min-width="120">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.state==1">未开始</div>-->
<!--          <div v-if="scope.row.state==2">进行中</div>-->
<!--          <div v-if="scope.row.state==3">已结束</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="活动时间" prop="" :min-width="160">-->
<!--        <template slot-scope="scope">-->
<!--          <div>{{ scope.row.startTime }} - {{ scope.row.endTime }}</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="对外展示" prop="" :min-width="80">
        <template slot-scope="scope">
          <el-switch
            @change="(e)=>changeState(e,scope.row)"
            v-model="scope.row.isShow"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" :min-width="180"></el-table-column>
      <el-table-column label="操作" fixed="right" prop="" width="260">
        <template slot-scope="scope">
          <div class="operation-area">
            <!-- 主要操作 -->
            <div class="operation-group">
              <el-button
                class="operation-btn primary"
                type="text"
                size="mini"
                @click="tableHandle(2, scope.row)">
                <i class="el-icon-data-analysis"></i>
                数据
              </el-button>
              <el-button
                class="operation-btn primary"
                type="text"
                size="mini"
                @click="tableHandle(1, scope.row)">
                <i class="el-icon-plus"></i>
                渠道
              </el-button>
              <el-button
                class="operation-btn primary"
                type="text"
                size="mini"
                @click="tableHandle(4, scope.row)">
                <i class="el-icon-view"></i>
                推广
              </el-button>
            </div>

            <!-- 状态操作 -->
            <div class="operation-group">
              <template v-if="scope.row.state == 1">
                <el-button
                  class="operation-btn status"
                  type="text"
                  size="mini"
                  @click="tableHandle(6, scope.row)">
                  <i class="el-icon-video-play"></i>
                  发布
                </el-button>
              </template>
              <template v-if="scope.row.state == 2">
                <el-button
                  class="operation-btn status"
                  type="text"
                  size="mini"
                  @click="tableHandle(7, scope.row)">
                  <i class="el-icon-video-pause"></i>
                  结束
                </el-button>
              </template>
              <template v-if="scope.row.state == 3 || scope.row.state == 2">
                <el-button
                  class="operation-btn status"
                  type="text"
                  size="mini"
                  @click="tableHandle(8, scope.row)">
                  <i class="el-icon-edit"></i>
                  编辑
                </el-button>
              </template>
            </div>

            <!-- 配置操作 -->
            <div class="operation-group">
              <el-button
                class="operation-btn config"
                type="text"
                size="mini"
                @click="tableHandle(5, scope.row)">
                <i class="el-icon-money"></i>
                现金奖励
              </el-button>
              <el-button
                class="operation-btn config"
                type="text"
                size="mini"
                @click="tableHandle(9, scope.row)">
                <i class="el-icon-tickets"></i>
                卡券奖励
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </my-table>
    <!-- 增加渠道弹窗 -->
    <el-dialog title="请输入渠道名称" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="channelDialogVisible" center width="50%" :before-close="channelHandleClose">
      <div v-loading="creatCodeLoading" class="channel_item" v-for="(item, index) in channelNameList" :key="index">
        <el-input type="text" v-model="channelNameList[index].channel" placeholder="请输入渠道类型"></el-input>
        <div style="margin: 0 5px;">-</div>
        <el-input type="text" v-model="channelNameList[index].linkName" placeholder="请输入渠道名称"></el-input>
        <div style="margin: 0 5px;">-</div>
        <el-input type="text" v-model="channelNameList[index].channelMobile" placeholder="请输入渠手机号"></el-input>
        <el-button @click="channelNameFn('add',index)" type="text" v-if="(channelNameList.length-1) == index">增行</el-button>
        <el-button @click="channelNameFn('del',index)" type="text" v-else>删除</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="channelHandleClose">取 消</el-button>
        <el-button type="primary" @click="channelHandleSubmit">生成二维码</el-button>
      </span>
    </el-dialog>
    <!-- 推广信息弹窗 -->
    <el-dialog title="推广信息" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="promotionDialogVisible" center width="60%" :before-close="promotionHandleClose">
      <el-table :data="activityPopularizeList" border style="width: 100%" size="mini">
        <el-table-column fixed="left" prop="linkName" label="渠道名称" width="120" align="center"></el-table-column>
        <el-table-column prop="linkCode" label="推广编码" width="160" align="center"></el-table-column>
        <el-table-column prop="channel" label="渠道类型" width="120" align="center"></el-table-column>
        <el-table-column prop="channelMobile" label="渠道手机号" width="120" align="center"></el-table-column>

        <el-table-column prop="date" label="普通二维码" align="center">
          <template slot-scope="scope">
            <div class="qrcode_img_src" :id="scope.row.linkCode"></div>
            <el-image
              v-loading="!scope.row.qrcodeSrc"
              style="width: 100px; height: 100px"
              :src="scope.row.qrcodeSrc"
              :preview-src-list="[scope.row.qrcodeSrc]">
            </el-image>
            <div class="popularize_list_qrcode">
              <el-button type="text" size="mini" @click="handleDownloadQR(scope.row)">下载普通二维码</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="小程序二维码" align="center">
          <template slot-scope="scope">
            <div class="popularize_list_qrcode">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.miniQrUrl"
                :preview-src-list="[scope.row.miniQrUrl]">
              </el-image>
              <el-button type="text" size="mini" @click="downloadQrcodeWx(scope.row)">下载小程序二维码</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="copyLink(scope.row)">点击复制链接</el-button>
            <el-button type="text" size="mini" @click="handelPhone(scope.row)">{{ scope.row.channelMobile?'更换手机号':'绑定手机号' }}</el-button>
            <el-button type="text" size="mini" @click="handelPhone(scope.row,'delete')" v-if="scope.row.channelMobile">解绑手机号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>


    <!-- 增加渠道弹窗 -->
    <el-dialog title="奖励配置" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="rewardDialogVisible" center width="80%" :before-close="rewardHandleClose">
      <el-table :data="commissionConfList" border style="width: 100%" size="mini" class="reward-table">
        <el-table-column prop="skuName" label="商品名称" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="sku-name">{{ scope.row.skuName }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="activityPrice" label="活动价格" min-width="120">
          <template slot-scope="scope">
            <div class="price-cell">¥{{ scope.row.activityPrice }}</div>
          </template>
        </el-table-column>

        <el-table-column label="一级裂变奖励" min-width="200">
          <template slot-scope="scope">
            <div class="reward-config">
              <el-select v-model="scope.row.fissionCommission.firstLevelAttrType" class="reward-type">
                <el-option :value="1" label="固定值"></el-option>
                <el-option :value="2" label="百分比"></el-option>
              </el-select>
              <el-input 
                v-model="scope.row.fissionCommission.firstLevelRewardVal" 
                @change="handleEdit(scope.$index, scope.row)"
                class="reward-value">
                <template slot="append">{{ scope.row.fissionCommission.firstLevelAttrType === 1 ? '元' : '%' }}</template>
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="二级裂变奖励" min-width="200">
          <template slot-scope="scope">
            <div class="reward-config">
              <el-select v-model="scope.row.fissionCommission.secondLevelAttrType" class="reward-type">
                <el-option :value="1" label="固定值"></el-option>
                <el-option :value="2" label="百分比"></el-option>
              </el-select>
              <el-input 
                v-model="scope.row.fissionCommission.secondLevelRewardVal" 
                @change="handleEdit(scope.$index, scope.row)"
                class="reward-value">
                <template slot="append">{{ scope.row.fissionCommission.secondLevelAttrType === 1 ? '元' : '%' }}</template>
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="渠道一级奖励" min-width="200">
          <template slot-scope="scope">
            <div class="reward-config">
              <el-select v-model="scope.row.channelCommission.firstLevelAttrType" class="reward-type">
                <el-option :value="1" label="固定值"></el-option>
                <el-option :value="2" label="百分比"></el-option>
              </el-select>
              <el-input 
                v-model="scope.row.channelCommission.firstLevelRewardVal" 
                @change="handleEdit(scope.$index, scope.row)"
                class="reward-value">
                <template slot="append">{{ scope.row.channelCommission.firstLevelAttrType === 1 ? '元' : '%' }}</template>
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="渠道二级奖励" min-width="200">
          <template slot-scope="scope">
            <div class="reward-config">
              <el-select v-model="scope.row.channelCommission.secondLevelAttrType" class="reward-type">
                <el-option :value="1" label="固定值"></el-option>
                <el-option :value="2" label="百分比"></el-option>
              </el-select>
              <el-input 
                v-model="scope.row.channelCommission.secondLevelRewardVal" 
                @change="handleEdit(scope.$index, scope.row)"
                class="reward-value">
                <template slot="append">{{ scope.row.channelCommission.secondLevelAttrType === 1 ? '元' : '%' }}</template>
              </el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="rewardHandleClose">取 消</el-button>
        <el-button type="primary" @click="rewardHandleSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import QRCode from "qrcodejs2";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
    data() {
    //这里存放数据
      return {
        listData: [],
        // 搜索数据
        searchData: {
          activityCode: "",
          activityName: "",
        },
        searchKey: "activityCode", //下拉input所选Key
        listLoading: false, //列表loading
        channelDialogVisible: false,           //增加渠道弹窗状态
        channelNameList: [                     //渠道名称list
          { channel: '', linkName: '' ,channelMobile: ''}
        ],
        promotionDialogVisible: false,        //推广信息弹窗
        rowActivityCode: "",                  //当前点击的活动code
        activityPopularizeList: [],           //活动推广列表
        url: "",
        rewardDialogVisible: false,
        commissionConfList: [],
        orderItems: [{
          "item":"createTime",
          "type":"desc"
        }],
        creatCodeLoading: false,
      };
    },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageHandler(params, num) {
      this.getActivityList(params, num ? num : params.pageNum, params.pageSize);
    },
    // 推广信息表格操作
    handelPhone(row,type){
      if(type == 'delete'){
        this.$confirm(`是否解绑此渠道手机号【${row.channelMobile}】?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('marketing/activityBindMobile',{
            linkCode: row.linkCode,
            channelMobile: ''
          }).then(res => {
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: '解绑成功!'
              });
              this.getActivityPopularizeList();
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          });
        });
      }else{
        this.$prompt('请输入手机号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: row.channelMobile,
          inputValidator: (val) => { if(!val) return '请输入手机号' }
        }).then(({ value }) => {
          this.$store.dispatch('marketing/activityBindMobile',{
            linkCode: row.linkCode,
            channelMobile: value
          }).then(res => {
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: '绑定成功'
              });
              this.getActivityPopularizeList();
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }

    },
    // 前端是否展示change更改状态
    changeState(e,row){
      this.$store.dispatch('management/postChangeShowStatus',{
        activityCode: row.activityCode,
        isShow: e,
      }).then(res => {
        this.$refs.list.init();
      })
    },
    // 表格内操作
    tableHandle(type, row) {
      this.rowActivityCode = row.activityCode;
      switch (type) {
        case 1:     //增加渠道
          this.channelNameList = [{ channel: '', linkName: '' }];
          this.channelDialogVisible = true;
          break;
        case 2:     //数据
        console.log(row)
          this.$router.push(`/management/fission/fission-analysis-page/${row.activityCode}?activityName=${row.activityName}`)
          break;
        case 3:     //复制

          break;
        case 4:     //查看推广信息
          // 获取推广信息列表
          this.getActivityPopularizeList();
          this.promotionDialogVisible = true;
          break;
        case 5:
          this.getActivityCommissionConf();
          this.rewardDialogVisible = true;
          break;
          case 6:
            this.publishActivity()
            window.location.reload();
            break
          case 7:
            this.closeActivity()
            window.location.reload();
            break;
          case 8:
            this.returnDraftActivity();
            window.location.reload();
            break
          case 9:
          this.$router.push(`/management/fission/fission-share-award?activityCode=${row.activityCode}&activityName=${row.activityName}`)
            break
        default:
          break;
      }
    },
    // 跳转活动详情
    gotoDetail(row){
      this.$router.push(`/management/fission/fission-campagin-add/${row.activityCode}`)
    },
    publishActivity(){
      this.$store.dispatch('marketing/publishActivity',{
        activityCode: this.rowActivityCode,
      }).then(res => {
        if(res.code == 0){
          this.$message.success('发布操作成功')
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    closeActivity(){
      this.$store.dispatch('marketing/closeActivity',{
        activityCode: this.rowActivityCode,
      }).then(res => {
        if(res.code == 0){
          this.$message.success('活动结束操作成功')
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    returnDraftActivity(){
      this.$store.dispatch('marketing/returnDraftActivity',{
        activityCode: this.rowActivityCode,
      }).then(res => {
        if(res.code == 0){
          this.$message.success('下线至草稿操作成功')
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    getActivityCommissionConf(){
      this.$store.dispatch('marketing/getCommissionConf',{
        activityCode: this.rowActivityCode,
      }).then(res => {
        if(res.code == 0){
          this.commissionConfList = res.data;
        }
      })
    },
    // 添加渠道弹窗关闭
    channelHandleClose(){
      console.log('添加渠道弹窗关闭')
      this.channelNameList = [{ channel: '', linkName: '' }];
      this.channelDialogVisible = false;
    },
    // 添加渠道生成二维码
    channelHandleSubmit(){
      let isNext = this.channelNameList.some(item => {
        return item.channel == '' || item.linkName == '';
      })
      if(isNext) return this.$message.error('请输入完整的渠道名称！');

      // 防重复点击
      if(this.nextStep) return
      this.nextStep = true;
      this.creatCodeLoading = true;

      this.$store.dispatch('marketing/newActivityPopularizeCreate',{
        activityCode: this.rowActivityCode,
        linkList: this.channelNameList
      }).then(res => {
        if(res.code == 0){
          // 获取推广信息列表
          this.getActivityPopularizeList()
          this.$message.success('添加成功')
          this.channelDialogVisible = false;
          this.promotionDialogVisible = true;
        }else{
          this.$message.error('创建失败，请稍后重试！')
        }
        this.nextStep = false;
        this.creatCodeLoading = false;
      }).catch(err => {
        console.log(err)
        this.nextStep = false;
        this.creatCodeLoading = false;
      })
    },
    // 添加\删除渠道
    channelNameFn(type,index){
      if(type == 'add'){
        this.channelNameList.push({ channel: '', linkName: '' })
      }
      if(type == 'del'){
        this.$confirm('是否删除此渠道?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.channelNameList.splice(index,1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    // 推广信息弹窗关闭
    promotionHandleClose(){
      this.promotionDialogVisible = false;
    },

    rewardHandleClose(){
      this.rewardDialogVisible = false;
    },

    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        activityCode: "",
        activityName: "",
      }
    },

    rewardHandleSubmit(){
      this.$store.dispatch('marketing/saveCommissionConf',{
        commissionConfItems: this.commissionConfList
      }).then(res => {
        if(res.code == 0){
          // 获取推广信息列表
         this.getActivityCommissionConf()
          this.$message.success('提交成功')
          this.rewardDialogVisible = false;
        }else{
          this.$message.error('提交失败，请稍后重试！')
        }
      })
    },

    // 复制链接
    copyLink(row){
      navigator.clipboard.writeText(row.linkUrl)
      .then(() => {
        this.$message.success('复制成功')
      })
      .catch(() => {
        this.$message.error('复制失败')
      })
    },
    qrCode(row,index) {
      document.getElementById(row.linkCode).innerHTML = "";
      let qrcode = new QRCode(row.linkCode, {
        width: 260, //图像宽度
        height: 260, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(row.linkUrl); //生成另一个新的二维码
      setTimeout(() => {
        let arr = JSON.parse(JSON.stringify(this.activityPopularizeList))
        var imgs = document.getElementById(row.linkCode).getElementsByTagName("img");
        arr[index].qrcodeSrc = imgs[0]['src'];
        this.activityPopularizeList = arr;
      }, 200);
    },
    handleDownloadQR(row) {
      var a = document.createElement("a");
      a.download = "QR" + new Date().getTime() || '普通二维码';
      a.href = row.qrcodeSrc;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    downloadQrcodeWx(row){
      var a = document.createElement("a");
      a.download = "QR" + new Date().getTime() || '小程序';
      a.href = row.miniQrUrl;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    // 获取活动列表
    getActivityList(params,pageNum,pageSize) {
      this.listLoading = true;
      this.$store.dispatch('marketing/newActivityList',{
        pageNum,
        pageSize,
        orderItems: this.orderItems,
        ...this.searchData
      }).then(res => {
        if(res.code == 0){
          this.listData = res.data.list;
          params.render(res.data.total);
        }
        this.listLoading = false;
      })
    },
    // 获取推广信息列表
    getActivityPopularizeList(){
      this.$store.dispatch('marketing/newActivityPopularizeList',{
        activityCode: this.rowActivityCode,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        if(res.code == 0){
          this.activityPopularizeList = res.data.list;

          setTimeout(() => {
            this.activityPopularizeList.map((item,index) => {
              this.qrCode(item,index)
            })
          }, 2000);
        }
      })
    },
    getStatusType(state) {
      const statusMap = {
        0: 'info',    // 草稿
        1: 'warning', // 未开始
        2: 'success', // 进行中
        3: 'danger'   // 已结束
      };
      return statusMap[state] || 'info';
    },
    getStatusText(state) {
      const statusMap = {
        0: '草稿',
        1: '未开始',
        2: '进行中',
        3: '已结束'
      };
      return statusMap[state] || '未知';
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
  .page_box {
    padding: 0 20px;
    background: #f5f7fa;
    min-height: 100vh;

    .search_box {
      background: #fff;
      padding: 24px;
      margin-top: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);

      .search-form {
        .form-content {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          margin-bottom: 20px;

          .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
            flex: 1;
            min-width: 240px;

            ::v-deep {
              .el-form-item__label {
                color: #606266;
                font-weight: 500;
                padding-right: 8px;
              }

              .el-input {
                .el-input__inner {
                  border-radius: 4px;
                  border-color: #dcdfe6;
                  transition: all 0.3s;

                  &:hover {
                    border-color: #c0c4cc;
                  }

                  &:focus {
                    border-color: #409EFF;
                  }
                }

                .el-input__prefix {
                  left: 8px;
                  color: #909399;
                }

                .el-input__inner {
                  padding-left: 32px;
                }
              }

              .el-select {
                width: 100%;

                .el-input__inner {
                  padding-left: 12px;
                }
              }
            }
          }
        }

        .form-footer {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          padding-top: 16px;
          border-top: 1px dashed #ebeef5;

          .el-button {
            padding: 8px 20px;
            font-size: 13px;
            border-radius: 4px;
            transition: all 0.3s;

            &--default {
              border-color: #dcdfe6;
              color: #606266;

              &:hover {
                color: #409EFF;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
              }
            }

            &--primary {
              background: #409EFF;
              border-color: #409EFF;

              &:hover {
                background: #66b1ff;
                border-color: #66b1ff;
              }
            }

            i {
              margin-right: 4px;
            }
          }
        }
      }
    }

    .table_nav_bar {
      width: 100%;
      background: #fff;
      padding: 20px;
      margin-bottom: 16px;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);
    }
  }

  .handle_btn {
    padding: 0;
    font-size: 13px;
    color: #409EFF;

    &:hover {
      color: #66b1ff;
    }
  }

  .channel_item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 12px;

    >.el-input:nth-child(1) {
      width: 260px;
    }

    .el-button {
      padding: 0 8px;
    }
  }

  .channel_item:last-child {
    margin: 0;
  }

  .popularize_list_qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .el-image {
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
  }

  .qrcode_img_src {
    position: absolute;
    top: -10000%;
    z-index: -10000;
  }

  .activity-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 12px 0;

    .activity-image {
      flex-shrink: 0;

      .el-image {
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 2px 8px 0 rgba(0,0,0,.1);
        transition: all 0.3s;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
        }
      }
    }

    .activity-detail {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .activity-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;

        .activity-name {
          flex: 1;
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .activity-status {
          flex-shrink: 0;
          .el-tag {
            border-radius: 12px;
            padding: 0 8px;
            height: 20px;
            line-height: 18px;
            font-size: 12px;
          }
        }
      }

      .activity-time {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 12px;
        color: #606266;
        background: #f5f7fa;
        padding: 8px 12px;
        border-radius: 4px;

        .time-item {
          display: flex;
          align-items: center;
          gap: 8px;

          .time-label {
            color: #909399;
            flex-shrink: 0;
          }

          .time-value {
            color: #606266;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .operation-area {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 0;

    .operation-group {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      padding: 2px 0;
      border-bottom: 1px dashed #ebeef5;

      &:last-child {
        border-bottom: none;
      }
    }

    .operation-btn {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      padding: 3px 6px;
      border-radius: 3px;
      transition: all 0.2s;
      font-size: 12px;
      min-width: 60px;
      justify-content: center;

      i {
        font-size: 13px;
      }

      &.primary {
        color: #409EFF;
        background: rgba(64, 158, 255, 0.08);

        &:hover {
          color: #fff;
          background: #409EFF;
        }
      }

      &.status {
        color: #67C23A;
        background: rgba(103, 194, 58, 0.1);

        &:hover {
          color: #fff;
          background: #67C23A;
        }
      }

      &.config {
        color: #E6A23C;
        background: rgba(230, 162, 60, 0.1);

        &:hover {
          color: #fff;
          background: #E6A23C;
        }
      }
    }
  }

  ::v-deep {
    .el-table {
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);
      margin-bottom: 20px;

      &__header {
        thead tr th {
          background: #f5f7fa;
          color: #606266;
          font-weight: 600;
          padding: 16px 0;
          height: 50px;
          line-height: 20px;
          font-size: 14px;
          border-bottom: 1px solid #ebeef5;
        }
      }

      &__body {
        tbody tr {
          td {
            padding: 16px 0;
            height: 60px;
            line-height: 20px;
            font-size: 14px;
            color: #606266;
            border-bottom: 1px solid #ebeef5;
            transition: all 0.3s;

            &:first-child {
              padding-left: 16px;
            }

            &:last-child {
              padding-right: 16px;
            }
          }

          &:hover td {
            background-color: #f5f7fa;
          }
        }
      }

      // 活动ID列样式
      .el-button--text {
        font-weight: 500;
        color: #409EFF;
        font-size: 13px;

        &:hover {
          color: #66b1ff;
        }
      }

      // 活动图列样式
      .el-image {
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 2px 8px 0 rgba(0,0,0,.1);
        transition: all 0.3s;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
        }
      }

      // 数字列样式
      .number-cell {
        font-family: 'Roboto Mono', monospace;
        font-weight: 500;
        color: #303133;
        text-align: right;
      }

      // 开关样式
      .el-switch {
        .el-switch__core {
          border-radius: 11px;
          height: 22px;
          width: 44px !important;

          &:after {
            width: 18px;
            height: 18px;
            top: 1px;
            left: 1px;
          }
        }

        &.is-checked .el-switch__core:after {
          left: 23px;
        }
      }

      // 操作列样式
      .el-button--text {
        padding: 0 8px;
        font-size: 13px;

        & + .el-button--text {
          margin-left: 0;
        }
      }

      .el-table__row {
        .activity-info {
          opacity: 0.9;
          transition: opacity 0.3s;
        }

        &:hover {
          .activity-info {
            opacity: 1;
          }
        }

        .operation-area {
          opacity: 0.9;
          transition: opacity 0.3s;
        }

        &:hover {
          .operation-area {
            opacity: 1;
          }
        }
      }
    }

    .el-dialog {
      border-radius: 8px;

      &__header {
        padding: 20px;
        border-bottom: 1px solid #ebeef5;
      }

      &__body {
        padding: 24px;
      }

      &__footer {
        padding: 16px 20px;
        border-top: 1px solid #ebeef5;
      }
    }

    .el-button {
      &--primary {
        background: #409EFF;
        border-color: #409EFF;

        &:hover {
          background: #66b1ff;
          border-color: #66b1ff;
        }
      }
    }
  }

  .button-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    align-items: flex-start;
    gap: 8px;
  }

  .reward-table {
    ::v-deep {
      .el-table__header {
        th {
          background-color: #f5f7fa;
          color: #606266;
          font-weight: 600;
          padding: 12px 0;
        }
      }

      .el-table__body {
        td {
          padding: 12px 0;
        }
      }
    }

    .sku-name {
      font-weight: 500;
      color: #303133;
    }

    .price-cell {
      color: #f56c6c;
      font-weight: 500;
      font-family: 'Roboto Mono', monospace;
    }

    .reward-config {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 8px;

      .reward-type {
        width: 90px;
      }

      .reward-value {
        flex: 1;
        
        ::v-deep {
          .el-input-group__append {
            padding: 0 8px;
            background-color: #f5f7fa;
            color: #909399;
            border-color: #dcdfe6;
          }
        }
      }
    }
  }

  ::v-deep {
    .el-dialog {
      border-radius: 8px;
      overflow: hidden;
      
      &__header {
        padding: 20px;
        background: #f5f7fa;
        border-bottom: 1px solid #ebeef5;
        
        .el-dialog__title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
        }
      }

      &__body {
        padding: 24px;
      }

      &__footer {
        padding: 16px 20px;
        border-top: 1px solid #ebeef5;
        text-align: right;

        .el-button {
          padding: 8px 20px;
          font-size: 14px;
          border-radius: 4px;
          
          &--primary {
            background: #409EFF;
            border-color: #409EFF;
            
            &:hover {
              background: #66b1ff;
              border-color: #66b1ff;
            }
          }
        }
      }
    }
  }
</style>
